




















































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import Chime from "@/resources/mixins/chime/chime";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import Loader, { CANCELLATION_TIME } from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";
import UserValidator from "@/resources/mixins/userValidator";
import { MEETING_TYPE } from "@/resources/constants/meeting";
@Component({
  name: "more-actions-menu-component",
  directives: { ClickOutsideDirective },
})
export default class MoreActionsMenuComponent extends mixins(
  Chime,
  FloatMenuAnimation,
  Loader,
  UserValidator
) {
  MEETING_TYPE = MEETING_TYPE;
  localSpaceUser = this.$store.getters["UserStore/getSpaceUser"];
  isSafari = false;
  mounted() {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const voiceEnabled = localStorage.getItem("voice_enabled") === "true";
    if (voiceEnabled) {
      this.$store.dispatch("MeetingStore/setVoiceIsEnabledAction", true);
    } else {
      this.$store.dispatch("MeetingStore/setVoiceIsEnabledAction", false);
    }
    const blur = parseInt(localStorage.getItem("blur_amount"));
    if (blur == 0) {
      this.$store.dispatch("MeetingStore/setBlurAmountAction", 0);
      this.$store.dispatch("MeetingStore/setBlurEnabled", false);
    } else {
      this.$store.dispatch("MeetingStore/setBlurAmountAction", blur);
      this.$store.dispatch("MeetingStore/setBlurEnabled", true);
    }
    const background = localStorage.getItem("background_image");
    if (background === "") {
      this.$store.dispatch("MeetingStore/setBackgroundImageAction", "");
      this.$store.dispatch("MeetingStore/setBackgroundEnabled", false);
    } else {
      this.$store.dispatch("MeetingStore/setBackgroundImageAction", background);
      this.$store.dispatch("MeetingStore/setBackgroundEnabled", true);
    }

    if (this.isSafari && this.voiceFocus) this.stopVoiceFocus();
  }
  get meetingType() {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  get backgroundIsSupport() {
    return this.$store.getters["MeetingStore/getBackgroundIsSupported"];
  }
  get backgroundImage() {
    return this.$store.getters["MeetingStore/getBackgroundImage"];
  }
  get blurIsSupport() {
    return this.$store.getters["MeetingStore/getBlurIsSupported"];
  }
  get blurAmount() {
    return this.$store.getters["MeetingStore/getBlurAmount"];
  }
  get voiceIsSupport() {
    return this.$store.getters["MeetingStore/getVoiceIsSupported"];
  }
  get deviceType() {
    return localStorage.getItem("deviceType");
  }
  get voiceFocus() {
    return this.$store.getters["MeetingStore/getVoiceIsEnabled"];
  }
  set voiceFocus(e) {
    if (e) this.addVoiceFocus();
    else this.stopVoiceFocus();

    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        isNoiseCancellationActivated: e ? true : false,
      },
      callback: (response) => {},
    });
  }
  get pressToTalk() {
    return this.$store.getters["MeetingStore/getPressToTalkEnabled"];
  }
  set pressToTalk(e) {
    this.muteOrUnmuteAudioInput(!e);
    this.$store.dispatch("MeetingStore/setMicEnabledAction", !e);
    this.$store.dispatch("MeetingStore/setPressToTalkEnabledAction", e);
  }
  close() {
    const menu = document.getElementById("more-actions-menu");
    if (menu.style.display === "block") this.closeCallMenu();
  }
  openBackgroundImages() {
    this.$store.dispatch("MeetingStore/setOpenBackgroundImagesAction", true);

    this.closeCallMenu();
  }
  openConfigDevices() {
    this.$store.dispatch("MeetingStore/setOpenDevicesConfigAction", true);

    this.closeCallMenu();
  }
  stopVideos() {
    this.stopAllVideo();
  }
  muteMics() {
    this.muteAllMics();
  }
  setBackground(image) {
    this.addBackgroundImage(image);
  }
  backgroundOff() {
    if (this.backgroundImage !== "") this.stopBackground();
  }
  setBlur(value) {
    this.addBackgroundBlur(value);
    this.parseBlur(value);
  }
  blurOff() {
    if (this.blurAmount !== 0) this.stopBlur();
    this.parseBlur(0);
  }
  parseBlur(value: number) {
    switch (value) {
      case 0:
        this.setConfiguration("OFF");
        break;
      case 2:
        this.setConfiguration("LOW");
        break;
      case 7:
        this.setConfiguration("MEDIUM");
        break;
      case 15:
        this.setConfiguration("HIGH");
        break;
    }
  }
  setConfiguration(value: string) {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        cameraBlur: value,
      },
      callback: (response) => {},
    });
  }
  async resetCall() {
    //Close Call
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (roomId) {
      this.startLoader(this.$store, CANCELLATION_TIME.CANCEL_CALL_30);
      this.setLoaderText(
        this.$store,
        i18n.t("loader.connectingRoom").toString()
      );
      this.$store?.dispatch("UserStore/loadPreviousStatusAction", {
        store: this.$store,
        callback: (response) => {
          this.$store?.dispatch("SpaceStore/updateUserInSpace", response.data);
          this.$store?.dispatch("MeetingStore/leaveMeetingAction", {
            roomId: roomId,
            callback: async (response) => {
              await this.$store?.dispatch("SidebarStore/setOpenCall", false);
              //Join Call
              await this.closeCall(roomId);
            },
            callbackError: (error) => {
              this.stopLoader(this.$store);
            },
          });
        },
        callbackError: (error) => {
          this.stopLoader(this.$store);
        },
      });
    }
    this.closeCallMenu();
  }
  async closeCall(roomId: any) {
    this.$store?.dispatch("MeetingStore/joinMeetingAction", {
      roomId,
      callback: async (response) => {
        if (!response.data.attendee && !response.data.meeting) return;
        await this.$store?.dispatch(
          "MeetingStore/setMeetingDataAction",
          response.data
        );
        this.$store?.dispatch(
          "MeetingStore/setIsVideoUrlLockedByAdminAction",
          response.data.isVideoUrlLockedByAdmin
        );
        await this.$store?.dispatch("SidebarStore/setOpenCall", true);
        await this.$store?.dispatch(
          "ChatStore/setMinimizeChatAction",
          !this.$store?.getters["UserStore/getConfig"].chat
            .openRoomChatByDefault
        );
        setTimeout(() => {
          this.$store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
        }, 20);
        await this.$store?.dispatch("ChatStore/joinRoomChatAction", { roomId });
        this.stopLoader(this.$store);
      },
      callbackError: (err) => {
        this.stopLoader(this.$store);
      },
    });
  }
}
